module.exports = __webpack_public_path__ + "static/Puia-Chhakchhuak-933101cd3bf654c88e30c918a971d5fe.jpg";